import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../../../../core/layout-components/search';

export const ContainerListClips = styled.div`
  background-color: white;
  border-radius: 4px;
  border: 1px solid #DEDEDF;
  margin: 10px;
  position: relative;
  width: 500px;
`;

export const ContainerInputSearch = styled.div`
  padding: 20px 0;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 5;
`;

export const InputSearch = styled(SearchLayoutComponent)`
  & > :first-child {
    width: 100%;
  }
`;

export const Message = styled(TextLayoutComponent)`
  color: #8A94AA;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  width: 100%;
`;
